import { ReportAggregateStore, ReportStore, ReportInqueryStore } from './utils'
import { initialState } from '../../utils/initialState'
export const updateSingle = (
  state: ReportStore,
  payload: ReportStore['reports']
): ReportStore => {
  return {
    ...state,
    reports: {
      ...state.reports,
      ...payload,
    },
  }
}
export const updateAggregate = (
  state: ReportAggregateStore,
  payload: ReportAggregateStore['aggregateReports']
): ReportAggregateStore => {
  return {
    ...state,
    aggregateReports: {
      ...state.aggregateReports,
      ...payload,
    },
  }
}
export const updateInquery = (
  state: ReportInqueryStore,
  payload: ReportInqueryStore['inqueryReports']
): ReportInqueryStore => {
  return {
    ...state,
    inqueryReports: {
      ...state.inqueryReports,
      ...payload,
    },
  }
}

export function initialStateAction(): ReportStore {
  return initialState
}
